
import { defineComponent } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '~/assets/util'

export default defineComponent({
  props: {
    musicians: { type: Array, required: false, default: undefined },
    schoolTypes: { type: Array, required: false, default: undefined },
    seasonTitle: { type: String, required: false, default: undefined },
    date: { type: Date, required: false, default: undefined },
    title: { type: String, required: false, default: undefined },
    introduction: { type: String, required: false, default: undefined },
    body: { type: String, required: false, default: undefined },
    theme: { type: String, required: false, default: undefined },
  },
  setup() {
    const { t_ } = setupTranslationPrefixer('EducationProductionDetailPageBody')
    return { t_ }
  },
})
